import { toast } from 'sonner';

/**
 * If an API error is a plan-limit (403 upgrade_required) error, show a friendly
 * toast with an "Upgrade" action and return true. Otherwise return false so the
 * caller can show its own generic message.
 */
export function handlePlanError(error, navigate, fallbackMessage) {
  const detail = error?.response?.data?.detail;
  if (error?.response?.status === 403 && detail && typeof detail === 'object' && detail.upgrade_required) {
    toast.error(detail.message || 'Upgrade required to continue.', {
      duration: 6000,
      action: { label: 'Upgrade', onClick: () => navigate('/membership') },
    });
    return true;
  }
  if (fallbackMessage) toast.error(fallbackMessage);
  return false;
}
